<template>
  <div>
    <v-container fluid>
      <v-container class="contain-width">
        <v-row class="pt-2 pb-2 pt-md-10 pb-md-10">
          <v-col md="5">
            <div class="fill-height">
              <div class="fill-height d-flex flex-column justify-space-between">
                <h1 class="h1 mb-6">Find what’s yours <br><span>A revolutionary solution to
                  finding <i>your</i> lost property</span></h1>
                <v-img
                    :src="require('@/assets/superpower.jpg')"
                    class="d-block d-md-none mb-6"
                    style="margin-top: 0px"
                    cover
                    alt="findmyit infographic"
                ></v-img>



                <div class="d-none d-md-flex justify-start mb-md-0">
                  <v-btn class="mr-16" x-large color="primary" rounded elevation="0" @click="showMore = !showMore"><v-icon left>{{ showMore ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>Tell me more</v-btn>
                  <v-btn x-large rounded outlined elevation="0" @click="introVideo = true"><v-icon left>
                    mdi-play
                  </v-icon>Play video</v-btn>
                </div>
                <div class="d-flex d-md-none flex-column justify-space-between mb-md-0">
                  <v-btn class="mb-6" x-large rounded outlined elevation="0" @click="introVideo = true"><v-icon left>
                    mdi-play
                  </v-icon>Play video</v-btn>
                  <v-btn color="primary" x-large rounded elevation="0" @click="showMore = !showMore"><v-icon left>{{ showMore ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>Tell me more</v-btn>
                </div>
              </div>
            </div>
          </v-col>
          <v-col class="d-none d-md-flex" md="6" offset-md="1">
            <!--              <vimeo-player ref="player" :video-id="videoID" @ready="onReady" class="player-container" :options="options">-->
            <!--              </vimeo-player>-->
<!--            <v-img-->
<!--                :src="require('@/assets/video-placeholder.jpg')"-->
<!--                class="float-end"-->
<!--                contain-->
<!--                style="margin-top: 0px"-->
<!--                alt="findmyit infographic"-->
<!--            ></v-img>-->

            <v-carousel
                v-model="slides"
                cycle
                interval="10000"
                show-arrows-on-hover
                hide-delimiters
                light
                continuous
                height="400px"
            >
              <v-carousel-item key="product-1" transition="fade-transition">
                <v-img
                    :src="slide1"
                    cover
                    alt="Iron on labels"
                ></v-img>
              </v-carousel-item>
              <v-carousel-item key="product-2" transition="fade-transition">
                <v-img
                    :src="slide2"
                    cover
                    alt="Sticker labels"
                ></v-img>
              </v-carousel-item>
              <v-carousel-item key="product-3" transition="fade-transition">
                <v-img
                    :src="slide3"
                    cover
                    alt="Key tags"
                ></v-img>
              </v-carousel-item>
              <v-carousel-item key="product-4" transition="fade-transition">
                <v-img
                    :src="slide4"
                    cover
                    alt="2 part bag tag"
                ></v-img>
              </v-carousel-item>
              <v-carousel-item key="product-5" transition="fade-transition">
                <v-img
                    :src="slide5"
                    cover
                    alt="Recovery card"
                ></v-img>
              </v-carousel-item>
            </v-carousel>

          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-expand-transition>
              <div v-show="showMore">
                <v-row>
                  <v-col cols="12" sm="12" md="5">
                    <p class="intro"><strong><i>Findmykit</i></strong> is a revolutionary way to reunite owners with their lost property. It's so simple, here's how:</p>
                    <p>Upon subscribing and becoming a <i>findmykit</i> member, you can choose from a wide selection of tags to secure onto any of your personal items. Each <i>findmykit</i> tag features a quick response (QR) code, which, when combined with our market-leading technology, notifies the owner of an item completely anonymously and securely. We have implemented profanity filters to ensure no inappropriate language or images can be exchanged between the finder and the owner.</p>
                    <p><v-img
                        :src="require('@/assets/example-tag.jpg')"
                        width="200"
                        class="float-left mr-6"
                    ></v-img> If an item is lost, the finder can scan the tag using their smartphone camera. This instantly sends a notification to the <i>findmykit</i> member's mobile phone, along with a simultaneous text message and email. The finder and owner can then engage in an anonymous conversation to arrange the collection or drop-off of the item, with no personal details shared.</p>
                    <p>To get started, simply sign up and follow our straightforward setup process.</p>
                  </v-col>
                  <v-col sm="12" md="6" offset-md="1">

                    <div class="d-flex flex-row justify-space-between">
                      <div>
                        <h2 class="h2 mb-6">Let's get you started...</h2>
                        <h3 class="h3 mb-4">£34.80 of products<br>included on subscription</h3>
                      </div>
                      <div class="d-none d-sm-block price" style="position: relative">
                                              <v-img
                                                :src="require('@/assets/fmk-circle.png')"
                                                width="200"
                                            ></v-img>
<!--                        <v-icon color="primary" size="200">mdi-decagram</v-icon>-->
                        <p class="text-center price-text">Only<br><strong>£25</strong><br>per year</p></div>


                    </div>



                    <ul class="products-list">
                      <li>25 Iron on labels</li>
                      <li>25 Sticker labels</li>
                      <li>3 Key tags</li>
                      <li>1 two part bag tag</li>
                      <li>1 Recovery card</li>
                    </ul>
                    <v-btn class="mt-6" rounded color="primary" elevation="0" x-large block @click="$router.push({name: 'sign-up-individual'})">SIGN ME UP</v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-expand-transition>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <v-container fluid class="white">
      <v-container class="contain-width pt-10 pb-5 pb-md-0">
        <h2 class="h2">Did you know...?</h2>
      <v-row class="">
        <v-col cols="12" offset="0" sm="10" offset-sm="1" md="5" xl="4" offset-md="0">

          <div class="fill-height d-flex flex-column justify-start">
            <div class="mt-6 mt-md-16">
              <p class="semi">In the UK every year:</p>
              <ul class="stats-list">
                <li>Over 5 million phones, <strong>LOST</strong></li>
                <li>2.6 million items of luggage, <strong>LOST</strong></li>
                <li>1.3 million wallets of purses, <strong>LOST</strong></li>
                <li>Only 20% of lost property is reclaimed</li>
              </ul>
            </div>
<!--            <p class="environment mt-12">See how we're <a href="#environment">helping our environment</a> <v-icon color="#6DC058" large>mdi-leaf</v-icon></p>-->
            <p class="solution mt-12">We have the solution <v-icon size="40" color="primary">mdi-chevron-double-right</v-icon></p>
          </div>
        </v-col>
        <v-col cols="12" md="7" xl="8">
          <v-row>
            <v-col cols="12" lg="8">
              <v-carousel
                  cycle
                  interval="5000"
                  :show-arrows="false"
                  hide-delimiters
                  light
                  class="white"
                  continuous
                  :height="$vuetify.breakpoint.xs ? 320 : $vuetify.breakpoint.sm ? 600 : $vuetify.breakpoint.md ? 480 : 480"
              >

                <v-carousel-item
                    key="item-1"
                    transition="scroll-x-transition"
                >
                  <v-img
                      :src="bagTag"
                      class="float-end mt-6"
                      contain
                      width="90%"
                      style="margin-top: 0px"
                      alt="Bag tags"
                  ></v-img>

                </v-carousel-item>
                <v-carousel-item
                    key="item-2"
                    transition="scroll-x-transition"
                >
                  <v-img
                      :src="phone"
                      contain
                      width="90%"
                      style="margin-top: 0px"
                      alt="Bag tags"
                      class="ml-6"
                  ></v-img>

                </v-carousel-item>
              </v-carousel>
            </v-col>
            <v-col cols="10" offset="1" sm="8" offset-sm="2" md="8" offset-md="2" lg="4" offset-lg="0">
              <div class="fill-height d-flex flex-column justify-space-around">
                <h2 class="h1 tag-it mb-6">Tag it...<br>
                  Scan it...<br>
                  Find it...
                </h2>
                <v-btn rounded elevation="0" color="primary" x-large @click="$router.push({name: 'sign-up-individual'})">SIGN ME UP</v-btn>
              </div>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
      </v-container>
    </v-container>

<!--    <v-container fluid class="white">-->
<!--      <v-carousel-->
<!--          cycle-->
<!--          interval="10000"-->
<!--          :show-arrows="false"-->
<!--          hide-delimiter-background-->
<!--          max-height="300"-->
<!--          light-->
<!--          class="white"-->
<!--      >-->

<!--        <v-carousel-item-->
<!--            key="item-1"-->
<!--        >-->
<!--          <v-container fluid class="contain-width pt-10">-->
<!--            <div class="d-flex justify-space-between">-->
<!--              <div>-->
<!--                <h2 class="h1">Did you know...?</h2>-->
<!--                <div class="ml-16 mt-16">-->
<!--                  <p class="semi">In the UK every year:</p>-->
<!--                  <ul class="bullet-list">-->
<!--                    <li>Over 5 million phones, <strong>lost</strong></li>-->
<!--                    <li>2.6 million items of luggage, <strong>lost</strong></li>-->
<!--                    <li>1.3 million wallets of purses, <strong>lost</strong></li>-->
<!--                  </ul>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div>-->
<!--                <v-img-->
<!--                    :src="bagTag"-->
<!--                    class="float-end"-->
<!--                    contain-->
<!--                    width="80%"-->
<!--                    style="margin-top: 0px"-->
<!--                    alt="Bag tags"-->
<!--                ></v-img>-->
<!--              </div>-->

<!--            </div>-->




<!--          </v-container>-->

<!--        </v-carousel-item>-->
<!--        <v-carousel-item-->
<!--            key="item-2"-->
<!--        >-->
<!--          <v-container fluid class="contain-width pt-10">-->
<!--            <v-row>-->
<!--              <v-col md="3" class="d-flex align-center">-->
<!--                <h2 class="h1 tag-it">Tag it<br>-->
<!--                  Scan it<br>-->
<!--                  Find it-->
<!--                </h2>-->
<!--              </v-col>-->
<!--              <v-col md="3" class="d-flex align-center">-->
<!--                <v-btn rounded color="#6DC058" x-large block>SIGN ME UP</v-btn>-->
<!--              </v-col>-->
<!--              <v-col md="6">-->
<!--                <v-img-->
<!--                    :src="phone"-->
<!--                    class="float-end"-->
<!--                    contain-->
<!--                    width="80%"-->
<!--                    style="margin-top: 0px"-->
<!--                    alt="Bag tags"-->
<!--                ></v-img>-->
<!--              </v-col>-->
<!--            </v-row>-->
<!--  &lt;!&ndash;          <div class="d-flex align-center">&ndash;&gt;-->
<!--  &lt;!&ndash;            <div>&ndash;&gt;-->
<!--  &lt;!&ndash;              <h2 class="h1 tag-it">Tag it<br>&ndash;&gt;-->
<!--  &lt;!&ndash;                Scan it<br>&ndash;&gt;-->
<!--  &lt;!&ndash;                Find it&ndash;&gt;-->
<!--  &lt;!&ndash;              </h2>&ndash;&gt;-->
<!--  &lt;!&ndash;            </div>&ndash;&gt;-->
<!--  &lt;!&ndash;            <div class="ml-16">&ndash;&gt;-->
<!--  &lt;!&ndash;              &ndash;&gt;-->
<!--  &lt;!&ndash;            </div>&ndash;&gt;-->
<!--  &lt;!&ndash;            <div>&ndash;&gt;-->
<!--  &lt;!&ndash;              <v-img&ndash;&gt;-->
<!--  &lt;!&ndash;                  :src="phone"&ndash;&gt;-->
<!--  &lt;!&ndash;                  class="float-end"&ndash;&gt;-->
<!--  &lt;!&ndash;                  contain&ndash;&gt;-->
<!--  &lt;!&ndash;                  width="50%"&ndash;&gt;-->
<!--  &lt;!&ndash;                  style="margin-top: 0px"&ndash;&gt;-->
<!--  &lt;!&ndash;                  alt="Bag tags"&ndash;&gt;-->
<!--  &lt;!&ndash;              ></v-img>&ndash;&gt;-->
<!--  &lt;!&ndash;            </div>&ndash;&gt;-->
<!--  &lt;!&ndash;          </div>&ndash;&gt;-->

<!--          </v-container>-->

<!--        </v-carousel-item>-->
<!--      </v-carousel>-->
<!--    </v-container>-->

    <v-container fluid>
      <v-container class="contain-width">
        <h2 class="h2 mb-10 pt-10">One persons happy story...</h2>
        <v-row class="pb-10">
          <v-col md="10" offset-md="1">
            <v-timeline
                :reverse="true"
                :dense="$vuetify.breakpoint.smAndDown"
            >
              <v-timeline-item
                  key="timeline-1"
                  color="#e5007f"
                  icon="mdi-laptop"
                  fill-dot
              >
                <span slot="opposite"><p>Findmykit tags come in many different formats including, stickers and iron on labels</p></span>
                <v-card class="elevation-2" color="#e5007f" dark>
                  <v-card-title class="text-h5 font-weight-bold">
                    Property lost
                  </v-card-title>
                  <v-card-text class="white text--primary">
                    <p><strong>Chloe leaves her laptop on the train. Fortunately, it has a Findmykit sticker attached.</strong></p>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
              <v-timeline-item
                  key="timeline-2"
                  color="purple darken-1"
                  icon="mdi-qrcode-scan"
                  fill-dot
              >
                <span slot="opposite"><p>Public tags can be scanned using any smart phone camera.</p></span>
                <v-card class="elevation-2" color="purple darken-1" dark>
                  <v-card-title class="text-h5 font-weight-bold">
                    Property found
                  </v-card-title>
                  <v-card-text class="white text--primary">
                    <p><strong>A member of the public finds her property and scans the QR code</strong></p>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
              <v-timeline-item
                  key="timeline-3"
                  color="green lighten-1"
                  icon="mdi-cellphone-text"
                  fill-dot
              >
                <span slot="opposite"><p>Messages are relaid through our secure system so that emails and phone numbers are not revealed, and profanity filters give you peace of mind.</p></span>
                <v-card class="elevation-2" color="green lighten-1" dark>
                  <v-card-title class="text-h5 font-weight-bold">
                    Conversation started
                  </v-card-title>
                  <v-card-text class="white text--primary">
                    <p><strong>Chloe receives a secure message from Findmykit to notify her, that her lost kit has been found.</strong></p>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
<!--              <v-timeline-item-->
<!--                  key="timeline-3"-->
<!--                  color="orange darken-2"-->
<!--                  icon="mdi-cellphone-text"-->
<!--                  fill-dot-->
<!--              >-->
<!--                <span slot="opposite"><p class="opposite">For example a public building or place of business.</p></span>-->
<!--                <v-card class="elevation-2" color="orange darken-2" dark>-->
<!--                  <v-card-title class="text-h6 font-weight-bold">-->
<!--                    Collection agreed-->
<!--                  </v-card-title>-->
<!--                  <v-card-text class="white text&#45;&#45;primary">-->
<!--                    <p>You agree a safeplace for collection</p>-->
<!--                  </v-card-text>-->
<!--                </v-card>-->
<!--              </v-timeline-item>-->
              <v-timeline-item
                  key="timeline-4"
                  color="indigo"
                  icon="mdi-emoticon-happy"
                  fill-dot
              >
                <span slot="opposite"><p>For example a public building or place of business.</p></span>
                <v-card class="elevation-2" color="indigo" dark>
                  <v-card-title class="text-h5 font-weight-bold">
                    Property returned
                  </v-card-title>
                  <v-card-text class="white text--primary">
                    <p><strong>Chloe agrees a safeplace for collection, and is re-united with her laptop. She thanks the person for being a good citizen.</strong></p>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-col>
        </v-row>

      </v-container>
    </v-container>

    <v-container fluid class="white" id="environment">
      <v-container class="contain-width">
        <v-row class="pt-10 pb-10">
          <v-col>

            <div class="mb-14">
              <v-img :src="require('@/assets/fmk-no-strap.png')" width="300" alt="findmykit"></v-img>
              <div class="d-flex flex-column flex-lg-row justify-start mb-10">
                <h2 class="h2 green--text text--darken-2">How we are helping our environment <v-icon color="#388E3C" x-large>mdi-leaf</v-icon></h2>
                <div class="mt-3 read-more"><v-btn rounded elevation="0" color="primary" @click="$router.push({name: 'environment'})" class="ml-lg-6">Take a look <v-icon right color="white">mdi-chevron-right</v-icon></v-btn></div>
              </div>

            </div>

            <v-row>
              <v-col class="col-12 col-lg-6">
                <vimeo-player ref="player" :video-id="videoIDEnvironment" @ready="onReady" class="player-container mt-3" :options="options">
                </vimeo-player>
              </v-col>
              <v-col class="col-12 col-lg-5 offset-lg-1">
                <v-row>
                  <v-col class="col-12">
                    <h3 class="h3 mb-6">Our planet needs our help</h3>
                    <p>With more than 300 items lost per person during a lifetime, and around 10 minute per day searching for lost property,
                      <strong><i>findmykit</i></strong> is a solution that circumvents the requirement to replace lost possessions.
                      Whilst the financial aspect is one of our priorities when it comes to having to buy replacement items, so to is the cost on the environment.</p>
                  </v-col>
                  <v-col class="col-6">
                    <v-img :src="require('@/assets/enviro-coin.jpg')" height="100%" alt="findmykit"></v-img>

                  </v-col>
                  <v-col class="col-6 d-flex flex-column justify-center">
                    <p class="annotation"><v-icon color="primary">mdi-chevron-left</v-icon> A durable synthetic paper with some serious green credentials</p>
                    <p class="annotation"><v-icon color="primary">mdi-chevron-left</v-icon> PPG Teslin© Biodegradable Substrate</p>
                  </v-col>
                </v-row>

              </v-col>
            </v-row>


          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <v-container fluid>
      <v-container class="contain-width">
        <v-row class="pt-10 pb-10">
          <v-col md="10" offset-md="1">
            <h2 class="h2 mb-10">Join us <span>for less than £2.10 per month</span></h2>

            <h3 class="h3 mb-6">Look at what you get with each £25 yearly subscription:</h3>

<!--            <h3 class="h3 mb-6">Your £25 yearly subscription includes:</h3>-->
<!--            <h3 class="h3 mb-6">Your £25 yearly subscription includes:</h3>-->

            <v-row>
              <v-col md="3" offset-md="1">
                <ul class="products-list">
                  <li :class="product === 0 ? 'primary--text' : ''">25 Iron on labels <v-icon v-if="product === 0" color="primary" size="30">mdi-chevron-right</v-icon></li>
                  <li :class="product === 1 ? 'primary--text' : ''">25 Sticker labels <v-icon v-if="product === 1" color="primary" size="30">mdi-chevron-right</v-icon></li>
                  <li :class="product === 2 ? 'primary--text' : ''">3 Key tags <v-icon v-if="product === 2" color="primary" size="30">mdi-chevron-right</v-icon></li>
                  <li :class="product === 3 ? 'primary--text' : ''">1 two part bag tag <v-icon v-if="product === 3" color="primary" size="30">mdi-chevron-right</v-icon></li>
                  <li :class="product === 4 ? 'primary--text' : ''">1 Recovery card <v-icon v-if="product === 4" color="primary" size="30">mdi-chevron-right</v-icon></li>
                </ul>
              </v-col>
              <v-col md="6">
                <v-carousel
                    v-model="product"
                    cycle
                    interval="5000"
                    :show-arrows="false"
                    hide-delimiters
                    height="300"
                    light
                    continuous
                >
                  <v-carousel-item key="product-1" transition="fade-transition">
                    <v-img
                        :src="product1"
                        cover
                        alt="Iron on labels"
                    ></v-img>
                  </v-carousel-item>
                  <v-carousel-item key="product-2" transition="fade-transition">
                    <v-img
                        :src="product2"
                        cover
                        alt="Sticker labels"
                    ></v-img>
                  </v-carousel-item>
                  <v-carousel-item key="product-3" transition="fade-transition">
                    <v-img
                        :src="product3"
                        cover
                        alt="Key tags"
                    ></v-img>
                  </v-carousel-item>
                  <v-carousel-item key="product-4" transition="fade-transition">
                    <v-img
                        :src="product4"
                        cover
                        alt="2 part bag tag"
                    ></v-img>
                  </v-carousel-item>
                  <v-carousel-item key="product-5" transition="fade-transition">
                    <v-img
                        :src="product5"
                        cover
                        alt="Recovery card"
                    ></v-img>
                  </v-carousel-item>
                </v-carousel>

              </v-col>
            </v-row>
            <div class="text-center">
              <v-btn class="mt-6 pr-12 pl-12" rounded elevation="0" color="primary" x-large @click="$router.push({name: 'sign-up-individual'})">SIGN ME UP</v-btn>
            </div>

          </v-col>
        </v-row>
      </v-container>
    </v-container>

<!--    <v-container fluid class="white">-->
<!--      <v-container class="contain-width">-->
<!--        <v-row class="pt-10 pb-10">-->
<!--          <v-col md="5" offset-md="1">-->
<!--            <div class="story">-->
<!--              <h2 class="h2 mb-10">Our customers love us</h2>-->
<!--              <p>Meet Sarah, a student at St.-->
<!--                Mary's School. One day, Sarah accidentally left her backpack in the school library after a study session. Panicked, she realised her bag contained her laptop, textbooks, and important personal belongings.</p>-->
<!--              <p>Luckily, Sarah had labelled her backpack with <strong><i>findmykit</i></strong>'s Smart tag. After realising her mistake, a fellow student discovered the bag and scanned the tag.-->
<!--                Instantly, Sarah received an email notification about her lost item.</p>-->
<!--              <p>With the help of <strong><i>findmykit</i></strong>, Sarah quickly retrieved her backpack from the kind student who found it. She expressed her gratitude and marvelled at how <strong><i>findmykit</i></strong>'s technology had saved her from a potentially stressful and costly situation.</p>-->
<!--            </div>-->
<!--          </v-col>-->
<!--          <v-col md="5" offset-md="1">-->
<!--            <img-->
<!--                :src="require('@/assets/sarah-1000x1000.jpg')"-->
<!--                alt="Sarah"-->
<!--            >-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--      </v-container>-->
<!--    </v-container>-->

    <v-container fluid class="white">
      <v-container class="contain-width">
        <v-row class="pt-10 pb-10">
          <v-col cols="12" md="5" offset-md="1">
            <div>
              <h2 class="h2 mb-10">What our customers are saying...</h2>

              <v-row dense>
                <v-col
                    v-for="card in testimonials"
                    :key="card.title"
                    cols="12"
                    lg="6"
                >
                  <v-card class="fill-height" flat tile>
<!--                    <v-card-title v-text="card.title"></v-card-title>-->
                    <v-card-text>
                      <blockquote>"{{ card.title }}"</blockquote>
                      <p class="credit">{{card.subtitle}}</p>

                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>


            </div>
          </v-col>
          <v-col cols="12" md="5" offset-md="1">
            <img
                :src="require('@/assets/collage.png')"
                alt="FMK collage"
            >
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <v-dialog
        v-model="introVideo"
        max-width="1000"
    >
        <vimeo-player ref="player" :video-id="videoIDIntro" @ready="onReady" class="player-container" :options="options">
        </vimeo-player>
    </v-dialog>

    <Footer />
  </div>


</template>

<script>

import {gmapApi} from 'vue2-google-maps'

let bagTag = require('@/assets/bag-tag-findmykit-banner.png')
let lostTeddy = require('@/assets/teddy-zoomed.jpg')
let phone = require('@/assets/phone-findmykit-banner.png')
let individual = require('@/assets/label-property.jpg')
let organisation = require('@/assets/lost-property.jpg')
let environment = require('@/assets/fmk-environment.jpg')

let product1 = require('@/assets/product-iron-on.png')
let product2 = require('@/assets/product-sticker.png')
let product3 = require('@/assets/product-key-tags.png')
let product4 = require('@/assets/product-2-part-bag-tag.jpg')
let product5 = require('@/assets/product-recovery-card-3d.png')

let slide1 = require('@/assets/carousel/1.png')
let slide2 = require('@/assets/carousel/2.png')
let slide3 = require('@/assets/carousel/3.png')
let slide4 = require('@/assets/carousel/4.png')
let slide5 = require('@/assets/carousel/5.png')

import axios from 'axios';

import {i18n} from "../i18n";
// import IndividualsSummary from "./IndividualsSummary";
// import MembershipForm from './MembershipForm'
//import OrganisationsSummary from "./OrganisationsSummary";
import {mapGetters, mapState} from "vuex";
import Footer from "./Footer.vue";

export default {
  name: "Home",
  metaInfo() {
    return {
      title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t("A revolutionary way to find what's yours"),
      htmlAttrs: {
        lang: i18n.locale
      },
      meta: [
        { name: 'description', content: i18n.t("{brand} is a solution to the vast and expensive problem of lost property", {brand: this.brandName}) + '. ' + i18n.t("A revolutionary way to find what's yours")}
      ]
    }
  },
  props: ['offsetTop'],
  data () {
    return {
      hover: false,
      membershipDialog: false,
      stripeKey: process.env.VUE_APP_STRIPE_KEY,
      alert: true,
      videoIDEnvironment: '410322496',
      videoIDIntro: '996613577',
      height: 1000,
      options: {'responsive': true, 'dnt': true},
      playerReady: false,
      bagTag: bagTag,
      lostTeddy: lostTeddy,
      phone: phone,
      individual: individual,
      organisation: organisation,
      environment: environment,
      product1: product1,
      product2: product2,
      product3: product3,
      product4: product4,
      product5: product5,
      slide1: slide1,
      slide2: slide2,
      slide3: slide3,
      slide4: slide4,
      slide5: slide5,
      markers: [],
      places: [],
      currentPlace: null,
      products: null,
      slides: null,
      show: false,
      locations: [],
      icons: {},
      infowindow: null,
      place: null,
      zoom: 9,
      mapLoading: false,
      socialLoading: false,
      showMore: false,
      product: 0,
      introVideo: false,
      testimonials: [
        { title: 'Lost my bag at a festival, but got it back thanks to findmykit!', subtitle: 'Jake M.' },
        { title: 'Super easy to set up and use. Highly recommend findmykit!', subtitle: 'Linda K.' },
        { title: 'Peace of mind knowing my items can be easily returned. Fantastic product!', subtitle: 'Anna S.' },
        { title: 'A must have for travelers. Got my suitcase back in no time', subtitle: 'Alex J.' },
        { title: 'Effortless to use and super effective. Highly satisfied!', subtitle: 'Megan W.' },
        { title: 'Incredible product! Found my misplaced laptop within hours.', subtitle: 'Tim H.' },
      ],
    }
  },
  components: {
    Footer
  },
  computed: {
    ...mapGetters('account', ['hasMembership', 'hasActiveTrial']),
    ...mapState({
      authenticated: state => state.authenticated,
      user: state => state.account.user,
      locale: state => state.locale,
      brand: state => state.brand,
      brandName: state => state.brandName
    }),
    google: gmapApi,
    tagName() {
      if (this.brand === 'neotag') {
        return 'NEOTAGS'
      }
      return 'SMART TAGS'
    },
    center() {
      if (this.brand === 'neotag') {
        return { lat: 39.4, lng: -0.4 }
      }
      return { lat: 51.2, lng: 0.5 }
    },
    cardWidth() {
      console.log(screen.width)
      if (screen.width <= 600) {
        //return (screen.width * 0.9) + 'px'
        return '100%'
      }
      return '600px'
    },
    getBackground() {
      return require('@/assets/neotag-background.jpg')
    },
    activ8Logo() {
      if (this.brand === 'neotag') {
        return require('@/assets/activ8-logo-alpha-dark.png')
      }
      return require('@/assets/activ8-logo.png')
    },
    isLight() {
      return Boolean(this.brand !== 'neotag')
    },
    bundlePrice() {
      if (this.brand === 'neotag') {

        return '€34.80'
      }

      return '£34.80'
    },
    subscriptionPrice() {
      if (this.brand === 'neotag') {
        return '€' + process.env.VUE_APP_SUBSCRIPTION_EUR
      }

      return '£' + process.env.VUE_APP_SUBSCRIPTION_GBP
    },
    sheetColor() {
      if (this.brand === 'neotag') {
        return '#292F33'
      }

      return 'white'
    },
    theme() {
      if (this.brand === 'neotag') {
        return 'dark'
      }

      return 'light'
    }
  },
  watch: {
    locale (to, from){
      if (to !== from) {
        this.loadBestProducts()
      }
    },
    // offsetTop (val) {
    //
    //   if (val > 1837 && this.mapLoading === false) {
    //     this.mapLoading = true
    //     console.log("map loading")
    //
    //     let apiClient = axios.create({
    //       baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
    //       withCredentials: true,
    //     });
    //
    //     apiClient.get('/sanctum/csrf-cookie').then(() => {
    //       apiClient
    //           .get('/api/organisations/coordinates')
    //           .then(response => {
    //             if (response.status === 200) {
    //               let organisations = response.data.data
    //               for (let key in response.data.data) {
    //                 let category = 'other';
    //                 if (organisations[key].organisation_category) {
    //                   category = organisations[key].organisation_category.slug
    //                 }
    //                 this.locations.push([organisations[key].name, organisations[key].latitude, organisations[key].longitude, 4, category])
    //               }
    //               this.doMap()
    //             }
    //           })
    //           .catch(error => {
    //             console.log(error)
    //           })
    //           .finally(() => this.show = true)
    //     })
    //   }
    //   if (val > 2456 && this.socialLoading === false) {
    //     this.socialLoading = true;
    //
    //     /* eslint-disable */
    //     (function (d, s, id) {
    //       var js, fjs = d.getElementsByTagName(s)[0],
    //           t = window.twttr || {};
    //       if (d.getElementById(id)) return t.widgets.load();
    //       js = d.createElement(s);
    //       js.id = id;
    //       js.src = "https://platform.twitter.com/widgets.js";
    //       fjs.parentNode.insertBefore(js, fjs);
    //
    //       t._e = [];
    //       t.ready = function (f) {
    //         t._e.push(f);
    //       };
    //       return t;
    //     }(document, "script", "twitter-wjs"));
    //     /* eslint-enable */
    //
    //     const facebook = document.createElement("script");
    //     facebook.setAttribute(
    //         "src",
    //         "https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v6.0"
    //     );
    //     facebook.async = true;
    //     document.head.appendChild(facebook);
    //   }
    // }
  },
  mounted () {

    // redirect for hash route such as /#/found/:qrCode
    let hash = location.hash;
    if (hash.includes('found/') && hash !== '') {
      this.$router.push({name: 'dashboard-found', params: { qrCode: hash.substring(hash.lastIndexOf('/') + 1)  }})
    }

    console.log('this is current player instance object', this.player)

    // this.locations = [
    //     ['Info', 51.188178, 0.244177, 4, 'educational'],
    // ];

    window.scrollTo(0,0);

    this.loadBestProducts()
  },
  methods: {
    closeForm() {
      this.membershipDialog = false
    },
    getBannerOverlay(slide) {
      if (this.brand === 'neotag') {
        if (slide === 1) {
          return require('@/assets/phone-neotag-banner.png')
        }
        else if (slide === 2) {
          return require('@/assets/recovery-card-neotag-banner.png')
        }
        else if (slide === 3) {
          return require('@/assets/keytags-neotag-banner.png')
        }
      }
      else {
        if (slide === 1) {
          return require('@/assets/phone-findmykit-banner.png')
        }
        else if (slide === 2) {
          return require('@/assets/recovery-card-fmk-banner.png')
        }
        else if (slide === 3) {
          return require('@/assets/keytags-findmykit-banner.png')
        }
      }
    },
    loadBestProducts() {
      this.show = false

      const instance = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale}
      });

      instance
          .get('/api/products/best?brand=' + this.brand)
          .then(response => {
            this.products = response.data.data
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.show = true
            window.prerenderReady = true;
          })
    },
    keyPoints(product) {

      if (product.points) {
        return product.points.split("\n")
      }

      return [];
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    onReady() {
      this.playerReady = true
    },
    play () {
      this.$refs.player.play()
    },
    stop () {
      this.$refs.player.stop()
    },
    // doMap () {
    //   // http://kml4earth.appspot.com/icons.html
    //   let iconBase = 'https://maps.google.com/mapfiles/kml/paddle/';
    //
    //   var marker, i;
    //
    //   let markers = [];
    //
    //   //var icons = this.icons;
    //   var infowindow
    //
    //   function addMarkerWithTimeout(location, timeout, map, google, icons) {
    //
    //     window.setTimeout(function() {
    //
    //       if (location[4] && location[1] && location[2]) {
    //         marker = new google.maps.Marker({
    //           position: new google.maps.LatLng(location[1], location[2]),
    //           map: map,
    //           icon: icons[location[4]].icon,
    //           animation: google.maps.Animation.DROP
    //         });
    //
    //         markers.push(marker);
    //
    //         google.maps.event.addListener(marker, 'click', (function(marker, i) {
    //           return function() {
    //             infowindow.setContent(location[0]);
    //             infowindow.open(map, marker);
    //           }
    //         })(marker, i));
    //       }
    //
    //     }, timeout);
    //
    //   }
    //
    //
    //
    //
    //
    //   this.$refs.mapRef.$mapPromise.then((map) => {
    //     infowindow = new this.google.maps.InfoWindow();
    //
    //     this.icons = {
    //       educational: {
    //         name: 'Educational',
    //         icon: {
    //           url: iconBase + 'red-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       },
    //       travel: {
    //         name: 'Transport & travel',
    //         icon: {
    //           url: iconBase + 'grn-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       },
    //       sports: {
    //         name: 'Sports and leisure',
    //         icon: {
    //           url: iconBase + 'blu-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       },
    //       retail: {
    //         name: 'Retail',
    //         icon: {
    //           url: iconBase + 'pink-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       },
    //       super: {
    //         name: 'Super partner',
    //         icon: {
    //           url: iconBase + 'ylw-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       },
    //       other: {
    //         name: 'Other',
    //         icon: {
    //           url: iconBase + 'wht-circle.png',
    //           scaledSize: new this.google.maps.Size(30, 30)
    //         }
    //       }
    //     };
    //
    //     let legend = document.getElementById('legend');
    //     for (let key in this.icons) {
    //       let type = this.icons[key];
    //       let name = type.name;
    //       let icon = type.icon.url;
    //       let div = document.createElement('div');
    //       div.style.color = 'black';
    //       div.className = "pin-div";
    //       div.innerHTML = '<img src="' + icon + '" width="30"> ' + name;
    //       legend.appendChild(div);
    //     }
    //
    //     //map.panTo({lat: 1.38, lng: 103.80})
    //     map.controls[this.google.maps.ControlPosition.RIGHT_BOTTOM].push(legend);
    //     for (i = 0; i < this.locations.length; i++) {
    //       addMarkerWithTimeout(this.locations[i], i * 200, map, this.google, this.icons);
    //     }
    //   })
    // },
    navigate (routeName, params) {
      this.$router.push({name: routeName, params: params})
    },
    // receives a place object via the autocomplete component
    // setPlace(place) {
    //     this.currentPlace = place;
    // },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    setDescription(description) {
      this.description = description;
    },
    setPlace(place) {
      this.place = place
      this.usePlace()
    },
    usePlace() {
      // https://github.com/xkjyeah/vue-google-maps/blob/vue2/examples/autocomplete.html
      if (this.place) {
        // this.markers.push({
        //     position: {
        //         lat: this.place.geometry.location.lat(),
        //         lng: this.place.geometry.location.lng(),
        //     }
        // })
        const marker = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.place = null;
        this.center = marker;
        this.zoom = 11
      }
    },
    downloadPdf() {
      axios({
        url: '/degradable-stock-spec-sheet.pdf',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'degradable-stock-spec-sheet.pdf');
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
    truncate (description, length) {
      if (description.length > length) {
        return description.substring(0, length) + '...';
      } else {
        return description;
      }
    }
  }
}
</script>

<style scoped lang="scss">

.story p {
  font-size: 1.2rem;
}
.read-more {
  font-family: "Open Sans", sans-serif;
  font-size: 1.4rem;
  font-weight: 600;
}

.price {
  position: relative;
  margin-top: -20px;
  .price-text {
    position: absolute;
    top: 30px;
    left: 0;
    font-family: "Open Sans", sans-serif;
    font-size: 2rem;
    width: 200px;
    height: 150px;
    line-height: 2.2rem;
  }
}
.h1 {
  font-size: 3.8rem;
  line-height: 4rem;
  font-family: "DM Serif Text", serif;
  font-weight: 400;
  font-style: normal;
  @media only screen and (max-width: 959px) {
    font-size: 2.6rem;
    line-height: 2.8rem;
  }
  span {
    font-size: 2.5rem;
    line-height: 3rem;
    margin-top: 3rem;
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-optical-sizing: auto;
    display: block;
    @media only screen and (max-width: 959px) {
      font-size: 2rem;
      line-height: 2.5rem;
      margin-top: 1rem;
    }
  }
}

.h2 {
  font-size: 3rem;
  line-height: 3.5rem;
  font-family: "DM Serif Text", serif;
  font-weight: 400;
  font-style: normal;
  @media only screen and (max-width: 959px) {
    font-size: 2.2rem;
    line-height: 2.2rem;
  }
  span {
    font-size: 1.8rem;
    line-height: 2.5rem;
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-optical-sizing: auto;
    @media only screen and (max-width: 959px) {
      font-size: 1.8rem;
      line-height: 2rem;
    }
  }
}

.h3 {
  font-size: 2rem;
  line-height: 2.6rem;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-style: normal;
  @media only screen and (max-width: 959px) {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

.tag-it {
  font-size: 3.8rem;
  line-height: 4rem;
  color: var(--v-primary-base);
}

.v-timeline-item__body p {
  padding-top: 1rem;
}

p.opposite {
  font-weight: 800;
}

.products-list li {
  font-size: 1.6rem;
  line-height: 2.5rem;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
}

.stats-list li {
  font-size: 1.6rem;
  line-height: 2.5rem;
  margin-bottom: 0;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  strong {
    font-weight: 500;
  }
  @media only screen and (max-width: 959px) {
    font-size: 1.6rem;
    line-height: 2.5rem;
  }
}

p.solution {
  color: var(--v-primary-base);
  font-size: 2.5rem;
  line-height: 2rem;
  font-family: "Open Sans", sans-serif;
  font-weight: 200;
  strong {
    font-weight: 500;
  }
  a {
    text-decoration: underline;
    text-decoration-thickness: 1px !important;
  }
  @media only screen and (max-width: 959px) {
    font-size: 1.6rem;
    line-height: 2.5rem;
  }
}

p.environment {
  color: var(--v-primary-base);
  font-size: 1.6rem;
  line-height: 2rem;
  font-family: "Open Sans", sans-serif;
  font-weight: 200;
  strong {
    font-weight: 500;
  }
  a {
    text-decoration: underline;
    text-decoration-thickness: 1px !important;
  }
  @media only screen and (max-width: 959px) {
    font-size: 1.6rem;
    line-height: 2.5rem;
  }
}

.semi {
  color: var(--v-primary-base);
  font-size: 2rem;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  @media only screen and (max-width: 959px) {
    font-size: 1.6rem;
  }
}



.steps h3 {
  color: var(--v-textOnPrimary);
  background-color: var(--v-primary-base);
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 2.145em;
  text-transform: uppercase;
  display: inline-block;
}
.steps p {
  color: black;
}
.steps p a {
  color: black;
  text-decoration: none;
}
.steps p a:hover {
  text-decoration: underline;
}

.cta-button:hover {
  color: #fff !important;
  text-decoration: none !important;
}
.slider-card {
  /*background-color: #fff;*/
  border-radius: 15px;
}
/*.cta-card {*/
/*  border-radius: 15px;*/
/*}*/
/*.cta-card-img {*/
/*  border-top-size: 5px;*/
/*  border-top-color: #E6E6E6;*/
/*  border-top-style: solid;*/
/*}*/
/*.cta-container {*/
/*  margin-top: -24px;*/
/*}*/
/*.cta-x-large {*/
/*  !*border-radius: 15px;*!*/
/*  padding-left: 50px !important;*/
/*  padding-right: 50px !important;*/
/*}*/
/*.cta-card .v-card__text, .v-card__actions {*/
/*  background-color: #E6E6E6;*/
/*  padding-left: 0;*/
/*  padding-right: 0;*/
/*}*/
button.mt-10 {
  border-radius: 12px;
  text-transform: none;
  font-weight: bold;
}
.carousel-sheet h1 {
  /*font-family: 'Lato', sans-serif !important;*/
  /*font-size: 3em;*/
  text-shadow: 2px 2px 4px black;
}
.v-application .display-1, .v-application .headline, .v-application div {
  font-family: 'Lato', sans-serif !important;
}
.v-application .display-1, .v-application .headline {
  font-weight: bold;
}
#legend {
  font-family: Arial, sans-serif !important;
  background: #fff;
  padding: 10px;
  margin: 10px;
  border: 3px solid #000;
}
#legend h3 {
  margin-top: 0;
}
#legend div {
  margin-bottom: 5px !important;
}
#legend img {
  vertical-align: middle;
}
.player-container {
  width: 100% !important;
}
.product-card {
  height: 100%;
  padding: 12px;
  border: inherit;
  /*padding-bottom: 60px;*/
}
.product-card .v-card__actions {
  padding-left: 15px;
  padding-bottom: 15px;
  position: absolute;
  bottom: 0;
}
.gradient1 {
  background: rgb(63,94,251);
  background: radial-gradient(circle, rgba(63,94,251,1) 0%, rgba(252,70,107,1) 100%);
}
#legend h3, #legend div {
  color: black !important;
}

.lifestyle-square {
  margin: 1px;
}
.annotation {
  font-family: "Open Sans", sans-serif;
  font-size: 1.2rem;
}
blockquote {
  font-family: "Open Sans", sans-serif;
  font-size: 1.2rem;
  line-height: 1.8rem;
  font-style: italic;
  margin-bottom: 6px;
  color: #333;
}
.credit {
  font-weight: 400;
  font-size: 0.9rem;
  color: #333;
}
</style>
